'use client';

import { c as _c } from "react/compiler-runtime";
import { InviteTab } from './InviteTab';
import { NoticeSection } from './NoticeSection';
import { RankingSection } from './RankingSection';
import { RewardSection } from './RewardSection';
import { StepSection } from './StepSection';
export const InviteContent = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InviteTab />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div id="reward-section" className="scroll-mt-46"><StepSection /><RewardSection /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t0}{t1}<div id="ranking-section" className="scroll-mt-46"><RankingSection /></div><NoticeSection /></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};